import React from 'react';
import {
  Actions,
  AppArea,
  Subjects,
  type RoleListFilterInput,
} from 'src/graphql/generated/graphql';
import { RolesTable } from './table/table';
import { useTable } from 'src/hooks/use-table';
import { Filter } from './filter';
import { CreateRoleButton } from './create-role-button';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { useRoles } from 'src/hooks/query/permissions/roles/use-roles';
import { Routes } from 'src/components/common/router/constants';
import { useNavigate } from 'react-router-dom';
import { Can } from 'src/utils/can';

const PAGINATION_LIMIT = 10;

export const RoleList = () => {
  const navigate = useNavigate();

  const { page, setPage, filter, onFilterChange, defaultFilter } = useTable<
    RoleListFilterInput,
    Record<any, any>
  >({
    defaultFilter: {
      isDisabled: null,
    },
  });

  const { loading, roles, totalCount } = useRoles({
    filter,
    pagination: {
      page,
      limit: PAGINATION_LIMIT,
    },
  });

  const onRowClick = (_: any, { rowIndex }: { rowIndex: number }) => {
    const role = roles[rowIndex];
    navigate(`${Routes.roles.path}/${role.id}`);
  };

  return (
    <Can I={Actions.Read} a={Subjects.Roles} appArea={AppArea.Admin}>
      <FilterWrapper>
        <Filter onSubmit={onFilterChange} defaultFilter={defaultFilter} />
      </FilterWrapper>

      <ContentWrapper>
        <TableWrapper>
          <div className="flex justify-end">
            <CreateRoleButton />
          </div>
          <RolesTable
            data={roles}
            className="mt-4"
            loading={loading}
            options={{
              page,
              count: totalCount,
              sort: true,
              rowsPerPage: PAGINATION_LIMIT,
              onChangePage: setPage,
              enableNestedDataAccess: '.',
              onRowClick,
            }}
          />
        </TableWrapper>
      </ContentWrapper>
    </Can>
  );
};
